import { useMemo, useCallback } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/schemas/search/v1/service.pb';
import { usePrimaryNavContent } from '../../layout/global-nav/nav-content';

export const useFilterFeatures = () => {
  const primaryNavContent = usePrimaryNavContent();
  const accessibleRoutes = useMemo(
    () =>
      primaryNavContent
        .filter((item) => item.show || item.show === undefined)
        .flatMap((navItem) => [
          navItem.root,
          ...navItem.subNavItems.map((subnavItem) => navItem.root + subnavItem.relativePath),
        ]),
    [primaryNavContent]
  );

  const filterFeatures = useCallback(
    (features: Feature[]) => {
      return features.filter((feature) => accessibleRoutes.includes(feature.path));
    },
    [accessibleRoutes]
  );

  return { filterFeatures };
};
